/**
 * PageviewTracker - Captures pageviews on route changes for SPA
 * 
 * Automatically tracks pageview events when users navigate between routes
 * in the single-page application. Only active when PostHog is initialized
 * (production environment).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';

/**
 * PageviewTracker Component
 * 
 * Place this component at the root of your router to enable automatic
 * pageview tracking. It uses PostHog's official usePostHog hook to
 * capture pageview events whenever the route changes.
 */
export function PageviewTracker() {
    const location = useLocation();
    const posthog = usePostHog();

    useEffect(() => {
        // Only capture pageview if PostHog is initialized (production only)
        if (posthog) {
            posthog.capture('$pageview');
        }
    }, [location.pathname, posthog]);

    return null;
}
